module.exports = "<vcm-landing *ngIf=\"landing\" [landing]=\"landing\" class=\"vcm_footer_bar\"></vcm-landing>";